import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Serializer } from "survey-core";
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { general,hotel,customer } from "../home/initial";

import React, { useState } from 'react';
import Toast from 'react-bootstrap/Toast';

import { axiosInstance } from "../axios/Axios";


const creatorOptions = {
    questionTypes: ["text", "checkbox", "radiogroup", "range","rating","comment"],
  showLogicTab: false,
  showJSONEditorTab :false,
  showEmbeddedSurveyTab:false,
  isAutoSave: true,
};

const defaultJson = {
  pages: [{
    name: "Untitled",
    elements: [{
      name: "Qn1",
      title: "Enter your first qn:",
      type: "text"
    }, {
      name: "Qn2",
      title: "Enter your second name:",
      type: "text"
    }]
  }]
};

export default function Creator() {

    const [showToast, setShowToast] = useState(false);
    const toggleShowToast = () => setShowToast(!showToast);

    const [msg, setMsg] = useState(null);
    const [subMsg, setSubMsg] = useState(null);
    
    useEffect(() => {

        var footbar = document.getElementsByClassName("svc-creator__banner")
        if (footbar.length >0)
        {
            footbar[0].style.display='None';
        }
    },[])

    const navigate = useNavigate();    
    const creator = new SurveyCreator(creatorOptions);

    creator.onShowingProperty.add(function(sender, options){
        if(options.obj.getType() == "survey") {
            options.canShow = options.property.name == "title";
        }
    });
  

  creator.text = window.localStorage.getItem("survey-json") || JSON.stringify(defaultJson);
  // if(window.localStorage.getItem("type")!==null)
  // {
  //   var temp = window.localStorage.getItem("type")
  //   if(temp==="edit")
  //     creator.text = window.localStorage.getItem("editJSON")
  //   else if(temp==="customer")
  //    creator.text = JSON.stringify(customer)
  //   else if(temp==="general")
  //   creator.text = JSON.stringify(general)
  //   else if(temp==="hotel")
  //   creator.text = JSON.stringify(hotel)
  // }

  creator.saveSurveyFunc = (saveNo, callback) => { 
    window.localStorage.setItem("survey-json", creator.text);
    callback(saveNo, true);
  };
  
  return (
    <>
        <SurveyCreatorComponent creator={creator} />
        
        <div style={{
              position:"fixed",
              bottom:"50px",
              right:"50px",
              width:"100%",
          }} 
        >
          <div id="create_display_msg" 
          style={{
            display:"inline-block",
          }}>
            <Toast show={showToast} onClose={toggleShowToast}>
              <Toast.Header>
                <strong className="me-auto">{msg}</strong>
              </Toast.Header>
              <Toast.Body>{subMsg}</Toast.Body>
            </Toast>
          </div>
          <Button style={{
                display:"inline-block",
                float:"right",
                padding:"10px 20px",
                borderRadius:"5px"
            }} 
            id="create_save_btn"
            variant="primary"
            onClick={()=>{

                var json = JSON.parse(localStorage.getItem("survey-json"))
                axiosInstance.post('survey/create/',json)
                .then((res) => {
                    var msg = res.data['msg']
                    if(msg==="success")
                    {
                      setMsg("Successful");
                      setSubMsg("Survey format saved successfully");
                      toggleShowToast();
                      window.localStorage.removeItem("survey-json");
                      navigate('/existing');
                    }
                    else if(msg==="No title")
                    {
                      // show a toast to change title
                      setMsg("Error");
                      setSubMsg("Enter title, Dont leave it empty");
                      toggleShowToast();
                    }
                    else if(msg==="Change title")
                    {
                      // show a toast to change title
                      setMsg("Error");
                      setSubMsg("Title Name already exits, Change it");
                      toggleShowToast();
                    }
                    else{
                      // show  toast as error
                      setMsg("Error");
                      setSubMsg("Try Again, mostly since, gsheet isnt created")
                      toggleShowToast();
                    }
                })
            }}
          >
            Save
          </Button>
        </div>

        
    </>
  )
}

// function saveSurveyJson(url, json, saveNo, callback) {
//   const request = new XMLHttpRequest();
//   request.open('POST', url);
//   request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
//   request.addEventListener('load', () => {
//       callback(saveNo, true);
//   });
//   request.addEventListener('error', () => {
//       callback(saveNo, false);
//   });
//   request.send(JSON.stringify(json));
// }